import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FaUsers, FaBullhorn, FaTrash, FaShieldAlt, FaChartBar, FaClock, FaCheck, FaTimes, FaStar } from 'react-icons/fa';

function Admin() {
  const [utilizatori, setUtilizatori] = useState([]);
  const [anunturi, setAnunturi] = useState([]);
  const [anunturiAsteptare, setAnunturiAsteptare] = useState([]);
  const [recenzii, setRecenzii] = useState([]);
  const [tabActiv, setTabActiv] = useState('statistici');
  const [incarca, setIncarca] = useState(true);
  const navigate = useNavigate();

  useEffect(function() {
    const token = localStorage.getItem('token');
    const userString = localStorage.getItem('utilizator');

    if (!token || !userString) {
      navigate('/');
      return;
    }

    const user = JSON.parse(userString);

    if (user.email !== 'andreibadea253@gmail.com') {
      toast.error('Acces restrictionat!');
      navigate('/');
      return;
    }

    incarcaDateAdmin(token);
  }, [navigate]);

  async function incarcaDateAdmin(token) {
    setIncarca(true);
    try {
      const resUtilizatori = await fetch('https://tranzitio.onrender.com/api/admin/utilizatori', {
        headers: { 'x-auth-token': token }
      });
      const resAnunturi = await fetch('https://tranzitio.onrender.com/api/anunturi/toate');
      const resAsteptare = await fetch('https://tranzitio.onrender.com/api/admin/anunturi/in-asteptare', {
        headers: { 'x-auth-token': token }
      });
      const resRecenzii = await fetch('https://tranzitio.onrender.com/api/recenzii/toate-admin', {
        headers: { 'x-auth-token': token }
      });

      if (resUtilizatori.ok) {
        setUtilizatori(await resUtilizatori.json());
      }
      if (resAnunturi.ok) {
        setAnunturi(await resAnunturi.json());
      }
      if (resAsteptare.ok) {
        setAnunturiAsteptare(await resAsteptare.json());
      }
      if (resRecenzii.ok) {
        setRecenzii(await resRecenzii.json());
      }
    } catch (err) {
      toast.error('Eroare la incarcarea datelor de administrare');
    } finally {
      setIncarca(false);
    }
  }

  async function stergeUtilizator(id) {
    const confirmat = window.confirm('Esti sigur? Aceasta actiune va sterge utilizatorul si toate anunturile lui!');
    if (!confirmat) {
      return;
    }
    const token = localStorage.getItem('token');
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/admin/utilizatori/' + id, {
        method: 'DELETE',
        headers: { 'x-auth-token': token }
      });
      const date = await raspuns.json();
      if (raspuns.ok) {
        toast.success(date.mesaj);
        incarcaDateAdmin(token);
      } else {
        toast.error(date.mesaj);
      }
    } catch (err) {
      toast.error('Eroare de conexiune');
    }
  }

  async function stergeAnunt(id) {
    const confirmat = window.confirm('Esti sigur ca vrei sa stergi acest anunt de pe platforma?');
    if (!confirmat) {
      return;
    }
    const token = localStorage.getItem('token');
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/admin/anunturi/' + id, {
        method: 'DELETE',
        headers: { 'x-auth-token': token }
      });
      const date = await raspuns.json();
      if (raspuns.ok) {
        toast.success(date.mesaj);
        incarcaDateAdmin(token);
      } else {
        toast.error(date.mesaj);
      }
    } catch (err) {
      toast.error('Eroare de conexiune');
    }
  }

  async function stergeRecenzie(id) {
    const confirmat = window.confirm('Sigur vrei sa stergi aceasta recenzie?');
    if (!confirmat) {
      return;
    }
    const token = localStorage.getItem('token');
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/admin/recenzii/' + id, {
        method: 'DELETE',
        headers: { 'x-auth-token': token }
      });
      const date = await raspuns.json();
      if (raspuns.ok) {
        toast.success(date.mesaj);
        incarcaDateAdmin(token);
      } else {
        toast.error(date.mesaj);
      }
    } catch (err) {
      toast.error('Eroare de conexiune');
    }
  }

  async function modereazaAnunt(id, statusModerare) {
    const token = localStorage.getItem('token');
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/admin/anunturi/' + id + '/modereaza', {
        method: 'PUT',
        headers: { 'x-auth-token': token, 'Content-Type': 'application/json' },
        body: JSON.stringify({ statusModerare: statusModerare })
      });
      const date = await raspuns.json();
      if (raspuns.ok) {
        if (statusModerare === 'aprobat') {
          toast.success('Anunt aprobat!');
        } else {
          toast.success('Anunt respins!');
        }
        incarcaDateAdmin(token);
      } else {
        toast.error(date.mesaj);
      }
    } catch (err) {
      toast.error('Eroare de conexiune');
    }
  }

  function calculeazaValoareTotala() {
    let total = 0;
    for (let i = 0; i < anunturi.length; i++) {
      total = total + (Number(anunturi[i].pret) || 0);
    }
    return total.toLocaleString('ro-RO');
  }

  function getClasaTab(numeTab) {
    const bazica = 'flex items-center gap-2 px-6 py-3 rounded-xl font-bold transition-all ';
    if (tabActiv === numeTab) {
      if (numeTab === 'asteptare') {
        return bazica + 'bg-amber-50 text-amber-700 shadow-sm border border-amber-100';
      }
      return bazica + 'bg-rose-50 text-rose-700 shadow-sm border border-rose-100';
    }
    return bazica + 'bg-white text-gray-500 hover:bg-gray-50 border border-gray-200';
  }

  if (incarca) {
    return (
      <div className="min-h-screen bg-[#f8fafc] flex justify-center items-center">
        <div className="w-12 h-12 border-4 border-rose-200 border-t-rose-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f8fafc] pb-16 font-sans">
      <div className="bg-rose-600 text-white py-8 shadow-md">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 flex items-center gap-4">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm">
            <FaShieldAlt className="w-8 h-8 text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-black tracking-tight">Panou Administrator</h1>
            <p className="text-rose-100 font-medium mt-1">Gestioneaza utilizatorii si continutul platformei Tranzitio</p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 lg:px-8 mt-8">
        <div className="flex flex-wrap gap-4 mb-8 border-b border-gray-200 pb-4">
          <button onClick={function() { setTabActiv('statistici'); }} className={getClasaTab('statistici')}>
            <FaChartBar className="w-5 h-5" />
            Statistici
          </button>
          <button onClick={function() { setTabActiv('asteptare'); }} className={getClasaTab('asteptare')}>
            <FaClock className="w-5 h-5" />
            In Asteptare
            {anunturiAsteptare.length > 0 && (
              <span className="bg-amber-500 text-white text-xs font-black px-2 py-0.5 rounded-full">
                {anunturiAsteptare.length}
              </span>
            )}
          </button>
          <button onClick={function() { setTabActiv('utilizatori'); }} className={getClasaTab('utilizatori')}>
            <FaUsers className="w-5 h-5" />
            Utilizatori ({utilizatori.length})
          </button>
          <button onClick={function() { setTabActiv('anunturi'); }} className={getClasaTab('anunturi')}>
            <FaBullhorn className="w-5 h-5" />
            Anunturi Active ({anunturi.length})
          </button>
          <button onClick={function() { setTabActiv('recenzii'); }} className={getClasaTab('recenzii')}>
            <FaStar className="w-5 h-5" />
            Recenzii ({recenzii.length})
          </button>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mt-6">

          {tabActiv === 'statistici' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 p-6">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex items-center gap-4">
                <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center">
                  <FaUsers className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-500 uppercase">Utilizatori</p>
                  <h3 className="text-2xl font-black text-gray-900">{utilizatori.length}</h3>
                </div>
              </div>
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex items-center gap-4">
                <div className="w-14 h-14 bg-emerald-50 text-emerald-600 rounded-xl flex items-center justify-center">
                  <FaBullhorn className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-500 uppercase">Anunturi Active</p>
                  <h3 className="text-2xl font-black text-gray-900">{anunturi.length}</h3>
                </div>
              </div>
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex items-center gap-4">
                <div className="w-14 h-14 bg-amber-50 text-amber-600 rounded-xl flex items-center justify-center">
                  <FaClock className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-500 uppercase">In Asteptare</p>
                  <h3 className="text-2xl font-black text-gray-900">{anunturiAsteptare.length}</h3>
                </div>
              </div>
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex items-center gap-4">
                <div className="w-14 h-14 bg-amber-50 text-amber-600 rounded-xl flex items-center justify-center">
                  <FaStar className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-500 uppercase">Recenzii</p>
                  <h3 className="text-2xl font-black text-gray-900">{recenzii.length}</h3>
                </div>
              </div>
            </div>
          )}

          {tabActiv === 'asteptare' && (
            <div className="overflow-x-auto">
              {anunturiAsteptare.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-20 text-gray-400">
                  <FaCheck className="w-12 h-12 mb-4 text-emerald-300" />
                  <p className="font-bold text-lg">Niciun anunt in asteptare</p>
                  <p className="text-sm mt-1">Toate anunturile au fost moderate.</p>
                </div>
              ) : (
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-amber-50 text-amber-700 text-xs uppercase tracking-wider">
                      <th className="p-4 font-bold">Anunt</th>
                      <th className="p-4 font-bold">Categorie</th>
                      <th className="p-4 font-bold">Pret</th>
                      <th className="p-4 font-bold">Data</th>
                      <th className="p-4 font-bold text-right">Actiuni</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {anunturiAsteptare.map(function(a) {
                      return (
                        <tr key={a._id} className="hover:bg-amber-50/30 transition-colors">
                          <td className="p-4">
                            <div className="flex items-center gap-3">
                              <div className="w-12 h-12 rounded-lg bg-gray-100 overflow-hidden shrink-0 border border-gray-200">
                                {a.imagine ? (
                                  <img src={a.imagine} alt="" className="w-full h-full object-cover" />
                                ) : (
                                  <div className="w-full h-full flex items-center justify-center text-xs text-gray-400 font-bold">Fara</div>
                                )}
                              </div>
                              <div>
                                <Link to={'/anunt/' + a._id} className="font-bold text-gray-900 line-clamp-1 hover:text-blue-600 transition-colors">
                                  {a.titlu}
                                </Link>
                                <div className="text-xs text-gray-400 font-mono mt-0.5">{a._id}</div>
                              </div>
                            </div>
                          </td>
                          <td className="p-4 text-sm font-medium text-gray-600">
                            <span className="bg-gray-100 px-2 py-1 rounded-md">{a.categorie}</span>
                          </td>
                          <td className="p-4 font-black text-blue-700">{a.pret} {a.moneda || 'RON'}</td>
                          <td className="p-4 text-sm text-gray-500">
                            {new Date(a.data).toLocaleDateString('ro-RO')}
                          </td>
                          <td className="p-4 text-right">
                            <div className="flex items-center justify-end gap-2">
                              <button
                                onClick={function() { modereazaAnunt(a._id, 'aprobat'); }}
                                className="flex items-center gap-1.5 bg-emerald-50 text-emerald-700 px-3 py-2 rounded-lg hover:bg-emerald-100 transition-colors font-bold text-sm"
                              >
                                <FaCheck className="w-3.5 h-3.5" />
                                Aproba
                              </button>
                              <button
                                onClick={function() { modereazaAnunt(a._id, 'respins'); }}
                                className="flex items-center gap-1.5 bg-red-50 text-red-600 px-3 py-2 rounded-lg hover:bg-red-100 transition-colors font-bold text-sm"
                              >
                                <FaTimes className="w-3.5 h-3.5" />
                                Respinge
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          )}

          {tabActiv === 'utilizatori' && (
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider">
                    <th className="p-4 font-bold">ID / Nume</th>
                    <th className="p-4 font-bold">Email</th>
                    <th className="p-4 font-bold">Telefon</th>
                    <th className="p-4 font-bold text-right">Actiuni</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {utilizatori.map(function(u) {
                    return (
                      <tr key={u._id} className="hover:bg-gray-50 transition-colors">
                        <td className="p-4">
                          <div className="font-bold text-gray-900">{u.nume}</div>
                          <div className="text-xs text-gray-400 font-mono mt-0.5">{u._id}</div>
                        </td>
                        <td className="p-4 text-sm font-medium text-gray-600">{u.email}</td>
                        <td className="p-4 text-sm font-medium text-gray-600">
                          {u.telefon ? u.telefon : '-'}
                        </td>
                        <td className="p-4 text-right">
                          {u.email !== 'andreibadea253@gmail.com' ? (
                            <button
                              onClick={function() { stergeUtilizator(u._id); }}
                              className="bg-red-50 text-red-600 p-2 rounded-lg hover:bg-red-100 transition-colors"
                              title="Sterge Utilizator"
                            >
                              <FaTrash className="w-4 h-4" />
                            </button>
                          ) : (
                            <span className="text-xs font-bold text-rose-600 bg-rose-50 px-3 py-1 rounded-full border border-rose-100">SUPER ADMIN</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {tabActiv === 'anunturi' && (
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider">
                    <th className="p-4 font-bold">Anunt</th>
                    <th className="p-4 font-bold">Categorie</th>
                    <th className="p-4 font-bold">Pret</th>
                    <th className="p-4 font-bold text-right">Actiuni</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {anunturi.map(function(a) {
                    return (
                      <tr key={a._id} className="hover:bg-gray-50 transition-colors">
                        <td className="p-4">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-lg bg-gray-100 overflow-hidden shrink-0 border border-gray-200">
                              {a.imagine ? (
                                <img src={a.imagine} alt="" className="w-full h-full object-cover" />
                              ) : (
                                <div className="w-full h-full flex items-center justify-center text-xs text-gray-400 font-bold">Fara</div>
                              )}
                            </div>
                            <div>
                              <Link to={'/anunt/' + a._id} className="font-bold text-gray-900 line-clamp-1 hover:text-blue-600 transition-colors">
                                {a.titlu}
                              </Link>
                              <div className="text-xs text-gray-400 font-mono mt-0.5">{a._id}</div>
                            </div>
                          </div>
                        </td>
                        <td className="p-4 text-sm font-medium text-gray-600">
                          <span className="bg-gray-100 px-2 py-1 rounded-md">{a.categorie}</span>
                        </td>
                        <td className="p-4 font-black text-blue-700">{a.pret} {a.moneda || 'RON'}</td>
                        <td className="p-4 text-right">
                          <button
                            onClick={function() { stergeAnunt(a._id); }}
                            className="bg-red-50 text-red-600 p-2 rounded-lg hover:bg-red-100 transition-colors"
                            title="Sterge Anunt"
                          >
                            <FaTrash className="w-4 h-4" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {tabActiv === 'recenzii' && (
            <div className="overflow-x-auto">
              {recenzii.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-20 text-gray-400">
                  <FaStar className="w-12 h-12 mb-4 text-amber-300" />
                  <p className="font-bold text-lg">Nicio recenzie pe platforma</p>
                </div>
              ) : (
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider">
                      <th className="p-4 font-bold">Autor</th>
                      <th className="p-4 font-bold">Nota</th>
                      <th className="p-4 font-bold">Comentariu</th>
                      <th className="p-4 font-bold">Data</th>
                      <th className="p-4 font-bold text-right">Actiuni</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {recenzii.map(function(r) {
                      const stele = [0, 1, 2, 3, 4];
                      return (
                        <tr key={r._id} className="hover:bg-gray-50 transition-colors">
                          <td className="p-4 font-bold text-gray-900">{r.numeAutor}</td>
                          <td className="p-4">
                            <div className="flex gap-0.5">
                              {stele.map(function(i) {
                                let clasa = 'w-4 h-4 text-gray-200';
                                if (i < r.nota) {
                                  clasa = 'w-4 h-4 text-amber-400';
                                }
                                return <FaStar key={i} className={clasa} />;
                              })}
                            </div>
                          </td>
                          <td className="p-4 text-sm text-gray-600 max-w-xs">
                            <span className="line-clamp-2">{r.comentariu}</span>
                          </td>
                          <td className="p-4 text-sm text-gray-500">
                            {new Date(r.data).toLocaleDateString('ro-RO')}
                          </td>
                          <td className="p-4 text-right">
                            <button
                              onClick={function() { stergeRecenzie(r._id); }}
                              className="bg-red-50 text-red-600 p-2 rounded-lg hover:bg-red-100 transition-colors"
                              title="Sterge Recenzie"
                            >
                              <FaTrash className="w-4 h-4" />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default Admin;